<template>
  <div class="privacyGame">
      <!-- style="color: red;" -->     
      <p><b>梅州实渲儿童个人信息保护政策</b>

</p><p><b>发布时间：2025年05月30日</b>
</p><p><b>生效时间：2025年05月30日</b>
</p><p><b>更新时间：2025年05月30日</b>

</p><p>欢迎您选择由梅州实渲网络科技有限责任公司（以下简称“本公司”或“我们”）为您提供的网络服务，<b> 为了保护儿童个人信息安全、促进儿童健康成长，我们特此制定本《梅州实渲儿童个人信息保护政策》（以下简称“本政策”），旨在向监护人（以下简称“您”）和您所监护的儿童说明我们如何收集、存储、使用、共享、转让、公开披露、删除儿童的个人信息，以及您和儿童所享有的相关权利等事宜。我们非常重视儿童的个人信息保护并充分尊重您及儿童的权利，在使用我们的产品和服务前，请您和儿童务必仔细阅读本政策，特别是以粗体标识的条款，您和儿童应重点阅读，在充分理解本政策后再同意儿童使用我们的产品及服务。儿童个人信息属于个人敏感信息，请您引导儿童增强个人信息保护意识并谨慎提供相关信息。如您不同意本政策的任何内容，您应引导儿童立即停止使用我们的产品及服务。 本政策仅适用于不满14周岁的儿童，儿童需通过监护人为其创建账户并经得监护人同意后才能使用我们提供的全部或部分网络服务。

</b></p><p>本政策为《梅州实渲儿童用户协议》的组成部分，本政策中未约定的事宜，适用《梅州实渲儿童用户协议》的约定。 

</p><p><b>摘要</b>

</p><p>本摘要主要向您说明<b>我们如何收集、处理儿童的个人信息以及儿童享有的个人信息权利，如您想详细了解儿童的个人信息处理情况，以及我们处理儿童个人信息的全部规则，请您阅读完整版《梅州实渲儿童个人信息保护政策》。

</b></p><p><b>一、我们如何收集和使用您的个人信息</b>

</p><p>为提供基本功能服务，我们需要收集以下信息：

</p><p>为提供注册、登录功能，我们将获取您的手机号码及短信验证码，或第三方账号公开信息（头像、昵称、身份验证信息以及您授权的相关信息）；在实名认证过程中，我们将获取您的姓名、身份证号。

</p><p>为帮助用户登录，防止用户账号变动后用户账号数据丢失及实现游戏更新，我们会收集移动设备的设备品牌、设备型号、设备版本、设备配置（包括存储内存）、设备平台、设备语言、手机运营商、手机制造商、手机CPU，设备MAC地址、设备硬件序列号、IMSI、IMEI、MEID、GAID（Android系统）、OAID（Android系统）、AndroidID（Android系统）、HarmonyOS(OAID、ODID）、UUID（iOS系统）、SIM卡序列号、IP地址、BSSID、SSID，应用安装列表、检索应用程序、进程信息。

</p><p>对于扩展业务功能所需信息，我们将根据您的授权进行收集和使用。

</p><p><b>二、我们如何共享您的个人信息</b>

</p><p>为保障我们的产品相关功能的实现及安全稳定运行，部分服务会由第三方提供，因此我们需要在儿童使用对应功能时向第三方共享儿童个人信息，您可以通过《与第三方共享个人信息清单》查看我们与第三方共享个人信息的情况。

</p><p><b>三、如何管理个人信息</b>

</p><p>您和儿童可以通过多种方式自行管理儿童个人信息，包括查询、更新账号中的个人基本资料信息，改变授权同意的范围，注销账户，如无法通过上述方式管理个人信息或在管理个人信息过程中遇到问题，可以与我们联系。

</p><p><b>四、未成年人信息保护</b>

</p><p>我们高度重视未成年人的保护工作，对于经监护人同意而收集未成年人个人信息的情况，我们只会在受到法律允许、监护人明确同意或者保护未成年人所必要的情况下使用或公开披露此信息。

</p><p><b>五、如何联系我们

</b></p><p>若对本政策或与儿童个人信息相关的事宜有任何问题、意见或建议，可以发送邮件至mzsxkefu@mzsxgames.com与我们联系。

</p><p><b>目录</b>

</p><p>1、我们如何收集和使用儿童个人信息
</p><p>2、我们如何使用Cookie和同类技术
</p><p>3、我们如何存储个人信息
</p><p>4、我们如何保护个人信息
</p><p>5、我们如何共享、转让、公开披露儿童的个人信息
</p><p>6、您及儿童的权利
</p><p>7、有关儿童个人信息处理的提示
</p><p>8、本政策的适用范围、变更以及例外情况
</p><p>9、联系方式

</p><p><b>1、我们如何收集和使用儿童个人信息</b>

</p><p>根据《常见类型移动互联网应用程序必要个人信息范围规定》，本产品属于网络游戏类APP，基本业务功能为提供网络游戏产品和服务，必要个人信息为：注册用户移动电话号码；根据《防止未成年人沉迷网络游戏的通知》，为落实网络游戏用户账号实名注册制度，儿童还需要提供姓名、身份证号。

</p><p>1.1 您须授权我们收集和使用儿童个人信息的情形

</p><p>为了向儿童提供本公司产品及服务的核心功能，我们会收集、使用下列个人信息，如果您拒绝提供相关信息，儿童将无法享受本公司产品或服务的基本业务功能，这些功能包括：

</p><p>1.1.1 注册登录

</p><p>如您同意儿童使用我们提供的产品或服务，当儿童使用账号注册或登录功能时，儿童可能会在注册或登录时主动向我们提供其个人基本资料，包括手机号码及短信验证码，上述信息为必要个人信息，如您不同意提供，儿童可能无法通过注册或登录从而使用我们的产品或服务。

</p><p>如儿童通过苹果应用商店、各大安卓应用商店下载或购买本公司产品或服务时，我们从该等应用商店处获取的儿童的信息，可能包括手机号码、账户信息，上述信息为必要个人信息，如您不同意提供，儿童可能无法通过该等第三方下载或购买本公司产品或服务。

</p><p>如您同意儿童授权以第三方账号，包括微博、微信、QQ或各手机品牌用户账号登录使用我们的服务时，我们将获取授权共享的该第三方账号下的相关信息，包括头像、昵称，以及身份验证信息，具体以您授权内容为准，并将该第三方账号与我们的服务账号进行绑定，以便儿童可以通过第三方账号直接登录并使用我们的服务，如您不同意授权此类信息的，儿童将无法使用第三方账号登录并使用我们的服务。

</p><p>1.1.2 身份认证

</p><p>为满足相关法律法规政策及相关主管部门的要求，儿童在开始或继续使用本公司游戏服务时需进行实名认证，我们会收集儿童的个人基本资料及个人身份信息，包括姓名、身份证号，个人身份信息属于个人敏感信息，且上述信息属于必要个人信息，如您不同意提供儿童个人身份信息可能会导致儿童无法使用我们的游戏服务，或在使用游戏服务过程中受到相应的限制。为实现实名认证的目的，您同意我们可以自行或委托第三方向有关机构提供、查询、核对儿童的前述身份信息。

</p><p>当我们根据实名身份信息识别出用户为不满14周岁的儿童时，我们可能会收集您的联系方式，包括手机号码、电子邮箱，并使用这些信息与您联系，以验证您与儿童的监护关系。

</p><p>1.1.3 保障游戏正常运行及运营安全

</p><p>为了您能够在客户端查看您的历史记录，同时用于我们的运营统计分析、客户投诉处理及服务体验分析，我们会收集您的日志信息，包括登录日志、物品日志、交友记录、以及游戏日志信息。

</p><p>为帮助用户登录，防止用户账号变动后用户账号数据丢失及实现游戏更新，我们会收集移动设备的品牌、型号、版本、配置（包括存储内存）、手机运营商、IMSI、IMEI、设备MAC地址、平台、语言、IP地址、BSSID、SSID、OAID（Android系统）、Android ID（Android系统）、UUID（iOS系统）、已安装应用列表、检索应用程序。



</p><p>1.2 您可选择是否授权我们收集和使用儿童个人信息的情形

</p><p>如儿童使用了本公司产品及服务的其他业务功能，我们会收集、使用下列个人信息，以为儿童提供本公司产品或服务的扩展业务功能：

</p><p>1.2.1 信息浏览、发布与下载

</p><p>如儿童使用我们产品或服务中的信息发布及相关交流互动功能，儿童可能会主动提供相关图文、视频、分享、互动行为信息。我们会收集记录上述信息，并展示儿童的昵称、头像、发布的信息内容，以便为儿童提供信息发布及相关交流互动功能并保存历史记录。请您注意，儿童在公开区域上传或发布的信息可能会被他人收集并加以使用，且这些信息中可能包括个人敏感信息，为保障儿童的人身和财产安全，请您谨慎提供。如您不同意提供仅会使儿童无法使用该功能，但不会影响儿童使用基本业务功能。

</p><p>在儿童访问产品特定功能页面时，我们会读取剪贴板内容以判断是否有相关口令码（包括邀请码、兑换码）信息，仅当剪贴板有前述口令码信息时，我们才会收集该口令码以向儿童提供所需的内容，我们不会存储剪贴板其他信息，其中兑换码属于个人敏感信息，请您谨慎提供。如您不同意提供仅会使儿童无法使用该功能，但不会影响儿童使用基本业务功能。

</p><p>在儿童使用该业务功能时，为了上传、下载分享或被分享的信息，我们需要获取安卓系统的存储权限，以读取和写入外置存储器，获取SD卡根目录、写入SD卡数据，获取存储的文件、图片、媒体内容，这些信息中可能包括个人敏感信息，为保障儿童的人身和财产安全，请您谨慎提供。如您不同意提供仅会使儿童无法使用相应功能，但不会影响儿童使用基本业务功能。

</p><p>当儿童使用游戏中的语音功能时，我们需要获取麦克风权限，以使用麦克风进行录音，获取录音内容。如您不同意提供仅会使儿童无法使用该功能，但不会影响儿童使用基本业务功能。

</p><p>当儿童需要本产品在其他程序上覆盖显示时，我们需要获取安卓系统的悬浮窗权限，以实现小窗体、悬浮、桌面显示功能。如您不同意提供仅会使儿童无法使用相应功能，但不影响儿童使用基本业务功能。

</p><p>1.2.2 消费与支付

</p><p>当儿童使用消费功能时，请确保儿童是经您授权同意后所进行的消费。儿童使用消费功能时，我们会收集充值记录、消费记录，以便查询交易记录，同时尽最大程度保护您以及儿童的财产安全。请您注意，充值记录、消费记录属于个人敏感信息，请您谨慎提供。如您不同意提供仅会使儿童无法使用该功能，但不会影响儿童使用基本业务功能。

</p><p>为帮助儿童完成支付，我们需要临时存储游戏道具信息，我们会读取公共存储区以获取道具列表信息，用于支付前验证道具信息。

</p><p>1.2.3 游戏活动

</p><p>如儿童参与游戏内抽奖活动或广告互动活动、使用要摇一摇功能，我们会获取设备重力传感器信息以判断儿童所使用的设备状态，确认儿童是否参与并实现前述互动。如您不同意提供仅会使儿童无法使用该功能，但不会影响儿童使用基本业务功能。

</p><p>如儿童使用游戏中的AR功能，我们需要获取相机权限，以使用设备摄像头并收集拍摄的照片、视频信息，这些信息中可能包括个人敏感信息，为保障儿童的人身和财产安全，请您谨慎提供。如您不同意提供仅会使儿童无法使用该功能，但并不影响儿童使用基本业务功能。

</p><p>1.2.4 添加好友与分享

</p><p>如儿童想邀请第三方账号中的好友使用我们的产品或服务、或向好友分享，我们可能需要从第三方处获取儿童授权登录账号的好友列表，以便儿童与朋友进行互动，好友列表属于个人敏感信息，请您谨慎提供，如您不同意提供仅会使儿童无法通过第三方授权登录账号的好友列表在我们的产品或服务中添加好友，但不会影响儿童使用基本业务功能。

</p><p>如儿童想添加附近的人为好友，我们需要获取安卓系统的位置权限，以获取精准地理位置信息，精准地理位置信息属于个人敏感信息，请您谨慎提供。如您不同意提供仅会使儿童无法使用该功能，但不会影响儿童使用基本业务功能。

</p><p>如儿童想扫描二维码添加好友，我们需要获取相机权限，以使用设备摄像头并收集拍摄的照片信息，如您不同意提供仅会使儿童无法使用该功能，但并不影响儿童使用基本业务功能。

</p><p>1.2.5 推送及公告

</p><p>我们可能通过您及儿童提供的联系方式（包括电子邮箱、手机号码）发送广告营销信息（不具备定向推送功能），提供或推广本公司或第三方的产品和服务，您及儿童可以在收到的信息中找到相关的提示，并可根据提示指引选择退订或取消订阅。

</p><p>我们可能在我们的服务发生变化时发出与服务有关的公告。您及儿童可能无法取消和限制这些与服务有关且性质不属于推广的公告。



</p><p>1.3 征得授权同意的例外。 根据相关法律法规及国家标准，我们可能会在以下情形中无需征求您的授权同意，收集、使用儿童的个人信息：

</p><p>1.3.1 为订立或者履行您及儿童与我们之间的合同所必需的；

</p><p>1.3.2 为本公司履行法定职责或法定义务所必需的；

</p><p>1.3.3 为应对突发公共卫生事件，或者紧急情况下为保护自然人的生命健康和财产安全所必需的；

</p><p>1.3.4 为公共利益实施新闻报道、舆论监督等行为在合理的范围内处理个人信息；

</p><p>1.3.5 与国家安全、国防安全直接相关的；

</p><p>1.3.6 与公共安全、公共卫生、公共网络安全、网络环境治理、重大公共利益直接相关的；

</p><p>1.3.7 与刑事侦查、起诉、审判和判决执行等直接相关的；

</p><p>1.3.8 出于维护您及儿童或其他个人的生命、财产等重大合法权益但又很难得到您本人同意的；

</p><p>1.3.9 所涉及的个人信息是您及儿童自行向不特定社会公众公开的；

</p><p>1.3.10 从合法公开披露的信息中收集个人信息的；

</p><p>1.3.11 法律法规规定的其他情形。



</p><p><b>2、我们如何使用 Cookie 和同类技术</b>

</p><p>为了统计或分析我们提供的网络产品及网络服务的运营效果，我们使用了若干自动数据收集工具，目前包括Cookie和Web beacon。借助这些技术，我们能够识别您监护儿童的产品使用情况以及预防欺诈。我们承诺不会将上述技术用于本政策所述目的之外的任何用途。如儿童所使用的设备或相关程序允许，您或者儿童可以通过改变设置、或通过访问提供商的网页，来关闭或删除上述技术，但这一举动可能会影响儿童的服务体验，部分服务也可能无法正常使用。



</p><p><b>3、我们如何存储个人信息</b>

</p><p>我们会根据相关法律法规的要求，遵循个人信息保存时间最小化原则，合理地保存您监护儿童的个人信息。

</p><p>3.1 保存的方式和期限

</p><p>我们会通过AES、RSA加密的方式存储您的信息，包括本地存储（例如利用APP进行数据缓存）、数据库和服务器日志等。

</p><p>在儿童使用公司服务期间，我们会持续保存其儿童的个人信息。如您或您监护的儿童对使用的账号进行注销或者公司产品停服，我们将从注销或停服之日起保存儿童个人信息3年，如法律法规对相关个人信息规定了更长的存储期限，则我们会在法律法规规定的最短期限内保存儿童的个人信息。在超出上述期限后，我们会对儿童的相关信息进行删除或匿名化处理。

</p><p>3.2 保存地域

</p><p>我们在中华人民共和国境内收集和产生的个人信息 ，将存储在中华人民共和国境内。

</p><p>3.3 个人信息如何在全球范围转移

</p><p>由于我们通过遍布全球的资源和服务器提供产品或服务，这意味着，在获得您的授权同意后，儿童个人信息可能会被转移到儿童使用产品或服务所在国家/地区的境外管辖区，或者受到来自这些管辖区的访问。此类管辖区可能设有不同的数据保护法，甚至未设立相关法律。在此类情况下，我们会确保儿童个人信息得到在中华人民共和国境内足够同等的保护。例如，我们会请求您对跨境转移儿童个人信息的同意，或者在跨境数据转移之前实施数据去标识化等安全举措。



</p><p><b>4 、我们如何保护您的个人信息</b>

</p><p>我们高度重视您监护儿童的个人信息的保护，采用了AES和RSA技术来确保儿童个人信息的安全，并严格设定儿童个人信息访问权限，控制儿童个人信息的知悉范围。

</p><p>4.1 我们已使用符合业界标准的安全防务措施保护您监护儿童提供的个人信息，防止数据遭到未经授权访问、公开披露、使用、修改、损坏或丢失。我们使用了下列各种安全技术和程序，保护儿童的个人信息：

</p><p>4.1.1 我们在浏览器或应用与服务器之间交换数据（如信用卡信息）时启用了SSL协议提供加密保护；

</p><p>4.1.2 我们采取了传输层安全协议等加密技术，通过HTTPS等方式提供浏览服务，确保数据在传输过程中的安全；

</p><p>4.1.3 我们确保第三方仅能通过HTTPS方式访问我们分享的API接口，我们只提供账号验证功能，因此第三方无法调取儿童的个人信息；同时我们采用了完善的防SQL注入手段，从而防止数据库系统受到外界攻击；

</p><p>4.1.4 我们采取加密技术对儿童的个人信息进行加密保存，儿童的密码是经过二次MD5等技术加密处理的，是密文信息；

</p><p>4.1.5 在某些服务中，我们还可能通过电话、短信等方式提醒您及您监护的儿童更改密码。

</p><p>4.2 您监护儿童的个人信息只允许被儿童个人信息保护负责人或其授权管理人员审批的工作人员访问，我们会记录工作人员的访问情况，并采取技术措施，避免违法复制、下载儿童个人信息。

</p><p>4.3 互联网并非绝对安全的环境，而且电子邮件、即时通讯、社交软件等与其他用户的交流方式无法确定是否完全加密，我们建议您帮助儿童在使用此类工具时使用复杂密码或不定期修改账号密码，并注意保护儿童个人信息安全。

</p><p>4.4 我们将尽力确保您及您监护的儿童发送给我们信息的安全。如果我们的物理、技术、或管理防护设施遭到恶意破坏，导致信息被非授权访问、公开披露、篡改、或毁坏，导致您及您监护儿童的合法权益受损，我们将承担相应的法律责任。

</p><p>4.5 如不幸发生个人信息安全事件，我们将按照法律法规的要求及时向您及您监护儿童告知：安全事件的基本情况和可能的影响、我们已采取或将要采取的处置措施、您可自主防范和降低风险的建议、补救措施等。我们会及时将事件相关情况以邮件、信函、电话、推送通知等方式告知您，难以逐一告知个人信息主体时，我们会采取合理、有效的方式发布公告。同时，我们还将按照监管部门要求，主动上报个人信息安全事件的处置情况。



</p><p><b>5 、我们如何共享、转让、公开披露您的个人信息</b>

</p><p>5.1 共享

</p><p>为了实现业务功能，我们可能会向第三方共享儿童个人信息，以实现儿童需要的服务或特定功能。我们仅会出于合法、正当、必要、特定、明确的目的共享儿童个人信息，并且只会共必要的个人信息。我们会通过签订协议的方式严格限制第三方使用儿童个人信息的行为，确保第三方按照我们的要求、本政策以及其他任何相关的保密和安全措施来处理个人信息。同时我们也会采取有效的技术保护措施保证个人信息在共享过程中的安全。我们会尽量对共享内容中的个人信息进行匿名化处理，您理解并同意，匿名化处理后的信息无法识别或关联到个人，已不属于法律意义上的个人信息，其处理、使用、共享、转让无需征得您的授权同意。

</p><p>目前，我们在以下情形中需要共享儿童的个人信息：

</p><p>5.1.1 为便于我们基于本公司统一的账号体系向儿童提供一致化服务以及便于您进行统一管理，保障系统和账号安全，儿童个人信息可能会在本公司产品内部进行必要共享。

</p><p>5.1.2 为保障我们的产品相关功能的实现及安全稳定运行，部分服务会由第三方提供，我们需要在儿童使用对应功能时向第三方共享儿童个人信息，包括通过软件工具开发包（SDK）或其他类似的应用程序的方式。您同意儿童在我们的产品中使用该等第三方提供的服务时，即代表您同意由其直接收集和处理儿童的个人信息，我们会努力审查该第三方的业务准入资质并努力要求其合法合规性与安全性。为了最大程度保障儿童信息安全，我们强烈建议您与儿童在儿童使用由第三方服务商提供的服务前先行查看其隐私条款。为保障儿童合法权益，如您发现第三方服务商提供的服务存在风险时，建议您指引儿童立即终止相关操作并及时与我们取得联系。目前，我们的产品与第三方共享个人信息的情况请查阅《与第三方共享个人信息清单》。

</p><p>5.2 转让

</p><p>我们不会将您监护儿童的个人信息转让给任何公司、组织或个人，但以下情况除外：

</p><p>5.2.1 如遇特殊情况，在获得您的明确授权同意后，我们会向其他方转让儿童的个人信息；

</p><p>5.2.2 在涉及合并、收购或破产清算时，如涉及到个人信息转让，我们会要求新的持有儿童个人信息的公司、组织继续受本政策的约束，否则我们将要求该公司、组织重新向您征求授权同意。

</p><p>5.3 公开披露

</p><p>我们仅会在以下情况下，公开披露儿童的个人信息：

</p><p>5.3.1 在获得您的明确授权同意后；

</p><p>5.3.2 基于有奖活动中的披露：如在公布中奖活动名单时，我们会在征得您同意后，脱敏展示中奖者手机号或登录名；

</p><p>5.3.3 基于法律的披露：在法律、法律程序、诉讼或政府主管部门强制性要求的情况下，我们可能会公开披露个人信息；

</p><p>5.4 社交网络

</p><p>为了用户可以与世界各地的用户沟通交流，我们为用户提供了社交网络服务。您监护的儿童如经您授权同意后使用我们的社交网络服务，请您注意，其他用户可能会在社交网络看到或分享您监护儿童的个人信息，请您务必关注儿童在社交网络上传或发布的个人信息，在其上传或发布信息之前需征得您的同意。为了保护儿童的个人信息安全，您可通过我们某些服务的隐私设置来控制有权浏览共享信息的用户范围，您还可以要求我们删除儿童的相关信息。如有任何我们可以协助的事宜，您可随时通过公司客服电话或邮箱与我们联系。

</p><p>5.4.1 儿童可能通过社交网络分享的个人信息：包括儿童在我们的服务中所上传或发布的信息（包括儿童公开的个人信息）、儿童对其他人上传或发布的信息作出的回应，儿童的战绩、排名，以及包括与这些信息有关的位置数据和日志信息；如您不同意在产品中公开前述儿童个人信息，可以自行根据产品内指引关闭。

</p><p>5.4.2 其他用户可能通过社交网络分享与儿童有关的信息；

</p><p>5.4.3 关于共享信息删除：只要您及儿童不删除共享信息，有关信息会一直留存在公共领域；即使您或儿童删除共享信息，有关信息仍可能由其他用户或不受公司控制的非关联第三方独立地缓存、复制或储存，或由其他用户或该等第三方在公共领域保存。

</p><p>5.5 共享、转让、公开披露个人信息时事先征得授权同意的例外。根据相关法律法规的规定，在以下情形中，我们共享、转让、公开披露个人信息不必事先征得您的授权同意：

</p><p>5.5.1 与公司履行法律法规规定的义务相关的；

</p><p>5.5.2 与国家安全、国防安全直接相关的；

</p><p>5.5.3 与公共安全、公共卫生、重大公共利益直接相关的；

</p><p>5.5.4 与刑事侦查、起诉、审判和判决执行等直接相关的；

</p><p>5.5.5 出于维护您及儿童或其他个人的生命、财产等重大合法权益但又很难得到您授权同意的；

</p><p>5.5.6 您自行向社会公众公开的个人信息 ；

</p><p>5.5.7 从合法公开披露的信息中收集个人信息的，如合法的新闻报道、政府信息公开等渠道 。



</p><p><b>6 、您的权利</b>

</p><p>在您授权您监护的儿童使用我们提供服务期间，我们可能会视服务具体情况为您以及儿童提供相应的操作设置，以便您以及儿童可以访问、查询、更正、删除相关个人信息，注销用户账户，撤销已同意的授权，获取个人信息副本。按照相关的法律法规，我们保障您以及您监护儿童对自己的个人信息行使以下权利。此外，我们还设置了投诉举报渠道，您可以通过第9章所述联系方式与我们取得联系，您的意见将会得到及时的处理。

</p><p>6.1 您以及儿童有权访问个人信息

</p><p>您以及儿童可以通过我们的产品或服务登录儿童的个人账号，随时访问账号中的个人基本资料信息，包括绑定我们产品或服务的手机号码，访问路径以各产品内部设置为准。您也可以在 《已收集个人信息清单》 中查阅我们收集您的个人信息的情况概要。

</p><p>如您以及儿童无法通过前述方式访问个人信息，可以通过渠道方的账号入口访问儿童在该渠道下的账号信息，如通过前述方式仍然无法访问个人信息，或您以及儿童需获取通过前述方式无法获知的个人信息内容，您以及儿童可以通过我们的电子邮箱（mzsxkefu@mzsxgames.com）与我们联系，我们将在15个工作日内给您回复。

</p><p>6.2 您以及儿童有权更正个人信息

</p><p>您以及儿童可以通过我们的产品或服务登录儿童的个人账号，随时更正账号中的个人基本资料信息，包括绑定我们产品或服务的手机号码，操作路径以各产品内部设置为准。

</p><p>如您以及儿童无法通过前述方式更正个人信息，可以通过渠道方的账号入口访问儿童在该渠道下的账号信息，如通过前述方式仍然无法更正个人信息，您以及儿童可以通过我们的电子邮箱（mzsxkefu@mzsxgames.com）与我们联系，我们将在15个工作日内给您回复。

</p><p>6.3 您以及儿童有权删除个人信息

</p><p>在以下情形中，您可以向我们提出删除儿童个人信息的请求：

</p><p>6.3.1 如果我们处理个人信息的行为违反法律法规；

</p><p>6.3.2 如果我们超出目的范围或者必要期限收集、存储、使用、转移、披露儿童个人信息的；

</p><p>6.3.3 如果我们处理儿童个人信息的行为违反了与您的约定；

</p><p>6.3.4 如果您监护的儿童不再使用我们的产品或服务，或您已为您监护的儿童注销了账号；

</p><p>6.3.5 如果我们不再为您监护的儿童提供产品或服务；

</p><p>6.3.5 如果您撤销了对于儿童个人信息处理的同意；

</p><p>您以及儿童可以通过我们的者电子邮箱（mzsxkefu@mzsxgames.com）联系我们删除个人信息，若我们决定响应您的删除请求，我们会在15个工作日内删除，我们还将同时通知从我们获得儿童个人信息的实体，要求其及时删除，除非法律法规另有规定，或这些实体获得您的独立授权。

</p><p>6.4 您有权改变您授权同意的范围

</p><p>我们向您监护儿童提供的每个业务功能都需要一些儿童的基本个人信息才能得以完成，目前我们产品关于个人信息的权限申请与使用情况可查阅《个人信息权限清单》。如您想更改相关权限的授权，您可以在儿童使用的设备中进行修改，具体操作路径为：设置—应用—权限管理，或设置—隐私，或在各产品内部通过隐私权限管理查阅个人信息的权限申请与使用情况并撤销权限使用的同意。

</p><p>如您无法通过前述方式改变您授权同意的范围您也可通过我们的客服电话（4008400188）或电子邮件（kefu@idreamsky.com）的方式向我们提出申请，我们将在15个工作日内回复您的请求。

</p><p>如您需要撤回收集必要个人信息的同意，或撤回收集全部个人信息的同意，将会导致我们无法为儿童提供本产品或服务的基本业务功能。在此情形下，如您仍希望撤回相关同意，您可以通过注销儿童的用户账户实现该需求，注销路径以以各产品内部设置为准。

</p><p>请您注意，在您收回同意的决定后，并不会影响此前基于您的授权而开展的个人信息处理。

</p><p>6.5 您以及儿童有权注销用户账户

</p><p>您以及儿童随时可注销此前注册的账户，您可以在我们的产品或服务的相关功能设置页面向我们提交注销申请，我们将在15天内注销您的账户。注销路径以各产品内部设置为准。

</p><p>如您以及儿童无法通过前述方式注销账户，您及儿童也可通过我们的客服电话（4008400188）或电子邮箱（kefu@idreamsky.com）向我们提出申请。在注销账户之后，我们将停止为儿童提供产品或服务，并依据您的要求，删除儿童的个人信息，但法律法规另有规定的除外。

</p><p>6.6 您有权申请获得您监护儿童的个人信息副本

</p><p>如您需要获取您监护儿童的个人信息副本，您可以通过我们的客服电话（4008400188）或电子邮件（kefu@idreamsky.com）向我们提出申请，我们将在15个工作日内回复您的申请。

</p><p>6.7 个人信息转移

</p><p>如您需要将儿童个人信息转移至指定的第三方的，您可以通过我们的客服电话（4008400188）或电子邮箱（kefu@idreamsky.com ）向我们提出申请，我们将在15个工作日内回复您的申请。在技术可行且符合国家网信部门规定条件的情况下，我们可以按照您的要求，将儿童的个人信息转移至您指定的第三方。

</p><p>6.8 信息系统自动决策的约束

</p><p>如我们使用的信息系统依据自动决策机制作出决定，且这些决定对您以及儿童的合法权益造成显著影响的，您以及儿童有权通过我们的客服电话（4008400188）或电子邮箱（kefu@idreamsky.com）向我们反馈或投诉，我们将对自动决策结果进行人工复核或提供其他适当的救济方式。

</p><p>6.9 响应您以及儿童的请求

</p><p>您以及儿童可以通过客服电话（4008400188）或电子邮箱（kefu@idreamsky.com ）向我们提出与个人信息相关的请求，我们会在15个工作日内响应。为保障安全，您以及儿童可能需要提供书面请求，或以其他方式证明您以及儿童的身份。我们可能会先要求您以及儿童验证自己的身份，然后再处理您以及儿童的请求。

</p><p>对您以及儿童的合理请求，我们原则上不收取费用，但如您以及儿童多次重复、超出合理限度的请求，请您理解我们将视情况收取一定成本费用。对于无端重复，需要过多技术手段，给他人合法权益带来风险或者不切实际的请求，很抱歉我们将可能会予以拒绝。

</p><p>6.10 特殊情况

</p><p>按照法律法规要求，很抱歉以下情形中我们将无法响应您以及儿童的请求：

</p><p>6.10.1 与本公司履行法律法规规定的义务相关的；

</p><p>6.10.2 与国家安全、国防安全直接相关的；

</p><p>6.10.3 与公共安全、公共卫生、重大公共利益直接相关的；

</p><p>6.10.4 与刑事侦查、起诉、审判和判决执行等直接相关的；

</p><p>6.10.5 有充分证据表明您存在主观恶意或滥用权利的；

</p><p>6.10.6 出于维护您监护儿童或其他个人的生命、财产等重大合法权益但又很难得到您本人同意的；

</p><p>6.10.7 响应您的请求将导致您监护儿童或其他个人、组织的合法权益受到严重损害的；

</p><p>6.10.8 涉及商业秘密的。



</p><p><b>7 、有关儿童个人信息处理的提示</b>

</p><p>7.1 处理儿童个人信息的必要性

</p><p>儿童未经监护人同意不得使用我们的服务，如儿童本人需要注册或使用我们的产品或服务，您应正确引导并履行监护职责，谨慎向我们提供儿童个人信息，保护儿童个人信息安全。如儿童经监护人同意后使用我们的服务，对于经监护人同意而收集儿童个人信息的情况，为了向您及儿童提供本政策所述产品功能及服务，我们只会在受到法律允许、监护人明确同意或者保护儿童所必要的情况下使用此信息。如果我们发现自己在未事先获得可证实的监护人同意的情况下收集了儿童的个人信息，我们会设法尽快删除相关数据。

</p><p>7.2 儿童个人权益保护

</p><p>我们会遵守本政策关于个人信息保护的约定收集、使用、存储、披露儿童个人信息，切实按照《儿童个人信息网络保护规定》的要求，遵循正当必要、知情同意、目的明确、安全保障、依法利用的原则处理儿童个人信息，当超过实现收集、使用目的所必须的期限后，我们会对儿童个人信息进行删除或匿名化处理。



</p><p><b>8 、本政策的适用范围、变更以及例外情况</b>

</p><p>8.1 适用范围

</p><p>本政策适用于本公司为不满14周岁的儿童提供网络服务的情况。当不满14周岁的儿童使用我们提供的任何单项产品或服务时，如该单项产品或服务有特定的隐私类政策，我们将在该单项产品或服务对应的隐私类政策（“特定政策”）中更具体地说明我们在该等服务中如何使用您监护儿童的个人信息。该特定政策构成本政策的一部分。如特定政策与本政策存在同类条款不一致的约定，则在该特定政策约束范围内以特定政策为准。

</p><p>我们的产品中可能包括指向第三方的链接，以帮助儿童访问第三方的服务或网站。我们请您特别注意，该等第三方服务是由相关第三方运营商提供，为保障儿童的合法权益，请您与儿童仔细阅读相关第三方的隐私类政策指引。

</p><p>8.2 本政策的变更

</p><p>我们可能会根据公司业务或相关政策的调整对本政策进行修订，为了保障您以及您监护儿童的用户知悉权，我们将在本政策修订生效前通过应用内弹窗的方式提示您及儿童阅读，并重新征得您的授权同意。如我们对本政策进行重大变更，我们还会提供更为显著的通知。本政策所指的重大变更包括但不限于：

</p><p>8.2.1 当我们的服务模式发生重大变化时，如收集儿童个人信息的范围、处理方式、以及使用目的发生变化等；

</p><p>8.2.2 当我们在所有权结构、组织架构等方面发生重大变化时，如业务调整、破产并购等引起的所有者变更等；

</p><p>8.2.3 当我们对儿童个人信息共享、转让或公开披露的主要对象发生变化时；

</p><p>8.2.4 当您以及您监护儿童参与个人信息处理方面的权利及其行使方式发生重大变化时；

</p><p>8.2.5 当我们负责处理个人信息安全的责任部门、联络方式及投诉渠道发生变化时；

</p><p>8.2.6 当我们的个人信息安全影响评估报告表明存在高风险时。



</p><p><b>9 、联系方式</b>

</p><p>如您对本政策有任何疑问、意见或建议，您可通过以下方式与我们联系。如您对我们的个人信息处理行为有任何投诉或申诉，您也可以通过以下方式与我们联系，我们会在15个工作日内回复处理意见或结果。

</p><p>公司名称：梅州实渲网络科技有限责任公司
</p><p>邮箱地址：mzsxkefu@mzsxgames.com
</p><p>注册地址：梅州市梅江区三角镇富奇路富奇城2栋第8号
</p><p>邮政编码：514021</p>


  </div>
</template>
<script>

export default {  
};
</script>